import { Error, Loader, SSDMaterialsList } from '../../common'
import { selectSelectedApprovalRequest } from '../../../selectors/approvalRequests'
import { isExamPaper } from '../../../selectors/examWindows'
import { isEmpty } from '../../../utils/common'
import { sortColumnByKey } from '../../../utils/sort'

const mapStateToProps = (state, ownProps) => {
  const { panelIsOpen } = ownProps
  const selectedApprovalRequest = selectSelectedApprovalRequest(state)
  const { students: studentsInOrder, fetching, error } = selectedApprovalRequest

  return {
    students: sortColumnByKey(
      studentsInOrder,
      ['studentLastName', 'studentFirstName'],
      ['asc', 'asc']
    ),
    fetching,
    error,
    panelIsOpen,
    isPaper: isExamPaper(
      state,
      selectedApprovalRequest.testCd,
      selectedApprovalRequest.examDateType
    ),
  }
}

const Students = connect(mapStateToProps)(({ students, fetching, error, isPaper }) => {
  if (error) {
    return <Error message={error} />
  }

  if (fetching) {
    return <Loader />
  }

  if (!isEmpty(students)) {
    return (
      <div className="row">
        <div className="col-xs-12" style={{ paddingBottom: '1.5em' }}>
          <table className="table table-condensed cb-no-table-border">
            <thead>
              <tr>
                <th>Student Name</th>
                <th>SSD Materials</th>
              </tr>
            </thead>
            <tbody>
              {students.map(({ studentLastName, studentFirstName, ssdDataSet }, i) => (
                <tr key={`${studentLastName}_${studentFirstName}_${i}`}>
                  <td>
                    {studentLastName}, {studentFirstName}
                  </td>
                  <td>
                    <SSDMaterialsList selectedSSDMaterials={ssdDataSet} isPaper={isPaper}>
                      <></>
                    </SSDMaterialsList>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  return null
})

export default Students
